<template>
  <div class="event-detail">
    <div class="inner">
      <p class="to-list-link"><router-link class="alp" to="/event/">イベント情報一覧ページ</router-link></p>
      <article>
        <div class="event-img">
          <img class="logo" :src="data.img">
        </div>
        <div>
          <h2 class="ttl" v-html="data.title"></h2>
          <p class="desc" v-if="data.theme" v-html="data.theme"></p>
          <a class="download-btn pdf alp" v-if="data.pdf" :href="data.pdf" target="_blank"><span>PDFデータをダウンロードする</span></a>
          <ul v-if="data.contents && data.contents.length">
            <ContentsList v-for="(d, i) in data.contents" :data="d" :key="data.ID + '_' + i"></ContentsList>
          </ul>
        </div>
      </article>
      <SearchCommonDetail v-if="data && data.ID" :currentId="data.ID" type="event" />
      <div class="to-list-btn"><a class="alp" href="/event/"><span>イベント情報一覧ページを見る</span></a></div>
      <p class="pagetop"><a class="alp" href="#">ページトップへ</a></p>
    </div>
    <div class="bottom-nav">
      <ul>
        <li class="concour alp"><a href="/concour/"><span>コンクール</span></a></li>
        <li class="teaching alp"><a href="/teaching/"><span>教材</span></a></li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;

$white-border: 0 2px 1px #fff, 2px 0 1px #fff, 0 -2px 1px #fff, -2px 0 1px #fff,
  -2px -2px 1px #fff, 2px -2px 1px #fff, -2px 2px 1px #fff, 2px 2px 1px #fff;

.event-detail {
  .inner {
    max-width: 1000px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10px;
    .to-list-link {
      padding: 30px 0;
      text-align: right;
      line-height: 1;
      a {
        font-size: 14px;
        color: $event;
        font-weight: 500;
        text-shadow: $white-border;
        position: relative;
        padding-left: 2em;
        letter-spacing: 0.1em;
        line-height: 1;
        background: url(../assets/img/common/arrow_bg_pc.png) no-repeat center
          left;
      }
      a:before {
        content: " ";
        display: block;
        width: 0;
        height: 0;
        border: 8px dashed transparent;
        border-right: 12px solid $event;
        position: absolute;
        top: calc(50% - 8px);
        left: -6px;
      }
    }
    article {
      padding: 40px 40px 5px;
      background: #fff;
      .event-img img {
        width: 100%;
      }
      h2 {
        font-size: 28px;
        font-weight: bold;
        padding: 30px 0 28px;
        line-height: 1.6;
      }
      h2 + p {
        font-size: 15px;
        line-height: 1.73;
        margin-bottom: 35px;
      }
      ul {
        li {
          border-bottom: 1px solid #d6d6d6;
          .desc {
            @include flex();
            padding: 25px 0;
            h3 {
              font-size: 18px;
              font-weight: bold;
              color: $event;
              line-height: 1.6;

              width: 18.5%;
            }
            p {
              font-size: 15px;
              width: 91.5%;
              line-height: 1.8;
            }
          }
          .map {
            height: 334px;
            border: 1px solid #ddd;
            margin-bottom: 30px;
          }
        }
        li:last-child {
          border-bottom: none;
        }
      }
      .download-btn {
        width: 44.5%;
        margin: 0 auto 30px;
        background: $event;
        color: #fff;
        span {
          padding-left: 30px;
          background-image: url(../assets/img/common/ico_download.png);
          background-repeat: no-repeat;
          background-size: 17px auto;
          background-position: center left;
        }
      }
    }
  }
  .ttl-select {
    margin: 85px 0 60px;
    @include flex();
    h2 {
      font-size: 34px;
      color: $event;
      font-weight: bold;
      text-shadow: $white-border;
    }
    p {
      font-size: 14px;
      font-weight: bold;
      text-shadow: $white-border;
      margin: 18px 0 0;
    }
    .select-area {
      width: 60.21%;
      > div:not(.search-btn) {
        width: 39%;
        label {
          color: $event;
          margin-bottom: 12px;
        }
        span {
          background-color: $event;
        }
      }
      input {
        background-color: $event;
      }
    }
  }
  .card-area {
    @include flex();
    flex-wrap: wrap;
  }
  .to-list-btn {
    width: 48.98%;
    margin: 40px auto 0;
    a {
      color: $event;
      border: 3px solid $event;
    }
    span {
      padding-left: 24px;
      &:before {
        content: " ";
        border: 8px dashed transparent;
        border-left: 12px solid $event;
        left: 0;
      }
    }
  }
  @media only screen and (max-width: 750px) {
    $white-border2: 0 1px 1px #fff, 1px 0 1px #fff, 0 -1px 1px #fff, -1px 0 1px #fff,
  -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff, 1px 1px 1px #fff;
    .inner {
      padding: 0;
      .to-list-link {
        margin: 0 -5.35vw;
        background: #fff;
        padding: 4vw 5.35vw;
        a {
          font-size: 0.8rem;
          display: inline-block;
        }
        a:before {
          border: 1.6vw dashed transparent;
          border-right: 2.2vw solid $event;
          top: calc(50% - 1.6vw);
        }
      }
      article {
        margin: 0 -5.35vw;
        padding: 0;
        .event-img + div {
          padding: 0 5.35vw 10.7vw;
        }
        h2 {
          line-height: 1.4;
          font-size: 1.625rem;
          padding: 5.4vw 0 3vw;
          + p {
            font-size: 1.025rem;
            line-height: 1.5;
            margin-bottom: 6vw;
          }
        }
        ul {
          li {
            .desc {
              display: block;
              padding: 5vw 0;
              h3 {
                width: 100%;
                font-size: 1.11rem;
                margin-bottom: 0.5vw;
              }
              p {
                width: 100%;

                font-size: 1.025rem;
                line-height: 1.4;
              }
            }
            .map {
              height: 44vw;
              margin-bottom: 5vw;
            }
          }

          li:last-child {
            border-bottom: 1px solid #d6d6d6;
          }
        }
        .download-btn {
          margin-bottom: 5vw;
        }
      }
    }
    .ttl-select {
      display: block;
      margin: 9.4vw 0 9.4vw;
      .ttl {
        margin-bottom: 8vw;
        text-align: center;
      }
      h2 {
        padding-left: 7vw;
        display: inline-block;
        letter-spacing: 0.05em;
        background-image: url(../assets/img/common/ico_event_sp.png);
        background-repeat: no-repeat;
        background-size: 6vw auto;
        background-position: center left;
        line-height: 1.4;

        font-size: 2.14rem;
      }
      p {
        margin-top: 3vw;
        font-size: 0.94rem;
        letter-spacing: 0.1em;
        text-shadow: $white-border2;
      }
      .select-area {
        flex-wrap: wrap;
        width: 100%;
        > div:not(.search-btn) {
          width: 48.5%;
        }
        label {
          color: $event;
        }
        span {
          background: $event;
          letter-spacing: 0;
        }
        input {
          width: 100%;
          background-color: $event;
        }
      }
    }
    .card-area {
      display: block;
      .card {
        width: 100%;
      }
    }
    .to-list-btn {
      border: 1.5px solid $event;
      margin: 8vw 0 1vw;
      span {
        padding-left: 4.8vw;
        &:before {
          border: 1.6vw dashed transparent;
          border-left: 2.4vw solid $event;
        }
      }
    }
  }
}
</style>

<script>
import Base from "./_Base";
import card from "../components/card";
import ContentsList from "../components/event_detail/ContentsList.vue";

export default {
  mixins: [Base],
  components: {
    card,
    ContentsList
  },
  computed: {
    data () {
      return (this.$store.state.data.eventDetail || {}).post || {}
    }
  },
  watch: {
    data (newData, oldData) {
      if (newData && newData.title && !oldData.title) {
        window.document.title = newData.title + ' | まなびアサヒ.com'
      }
    }
  }
};
</script>
